<template>
  <section class="blood-app">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="app__content">
            <h2>تطبيق بنك الدم</h2>
            <p>
              هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة ، لقد تم توليد
              هذا النص من مولد النص العرب
            </p>
            <h3>متوفر علي</h3>
            <div class="stores">
              <a href="#" class="store">
                <img src="../../content/imgs/google.png" alt="" />
              </a>
              <a href="#" class="store">
                <img src="../../content/imgs/ios.png" alt="" />
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 text-sm-center">
          <img src="../../content/imgs/App.png" alt="" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>
